import React from "react";
import { Row, Col, Divider, Empty, Button } from "antd";
import {
  BankOutlined,
  CalendarOutlined,
  DollarOutlined,
  PrinterOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import THEME from "../theme";
import { formatMoney, formatDate } from "../utils";
import StyledCard from "../components/StyledCard";
import StatBox from "../components/StatBox";
import InfoItem from "../components/InfoItem";

const LoanNewInfoJudgeTab = ({
  judgeData,
  handlePrintCardDebtor,
  beeypupData,
}) => {
  const loan = judgeData?.judge?.[0];
  if (!loan) return <Empty description="ไม่มีข้อมูล" />;

  const dataBeeypup = () => {
    if (!Array.isArray(beeypupData) || beeypupData.length === 0) return "-";

    const result = beeypupData.reduce((sum, item) => {
      const beeypup = Number(item?.BEEYPUP) || 0;
      const payBeeypup = Number(item?.PAY_BEEYPUP) || 0;
      return sum + (beeypup - payBeeypup);
    }, 0);

    return `${formatMoney(result) || "-"} บาท`;
  };

  const firstJudge = loan;

  const totalJudgement =
    Number(firstJudge?.judgement || 0) +
    Number(firstJudge?.AROTHR || 0) +
    Number(firstJudge?.costOfUselessness || 0);

  const totalPaid = (judgeData?.chqtran ?? [])
    ?.filter((r) => r.FLAG !== "C")
    .reduce((sum, item) => sum + parseFloat(item.PAYAMT_N || 0), 0);

  const totalPaidArothr = (judgeData?.chqtran_arothr ?? [])
    ?.filter((r) => r.FLAG !== "C")
    .reduce((sum, item) => sum + parseFloat(item.PAYAMT || 0), 0);

  const totalPaidAll = parseFloat(totalPaid + totalPaidArothr);

  return (
    <StyledCard
      title="ข้อมูลสัญญา(พิพากษา)"
      icon={<BankOutlined style={{ color: THEME.primary, fontSize: 18 }} />}
      style={{ marginBottom: 16 }}
      extra={
        <Button
          type="primary"
          icon={<PrinterOutlined />}
          onClick={handlePrintCardDebtor}
          size="small"
        >
          พิมพ์
        </Button>
      }
    >
      <Row gutter={[16, 16]}>
        <Col xs={12} sm={8} md={6}>
          <StatBox
            title="ยอดจัดทั้งหมด"
            value={loan?.totalJugde}
            color={THEME.primary}
            icon={<DollarOutlined />}
          />
        </Col>
        {/* <Col xs={12} sm={8} md={6}>
          <StatBox
            title="ชำระแล้ว"
            value={loan?.LOAN_NEW_SMPAY}
            color={THEME.success}
            icon={<CheckCircleOutlined />}
          />
        </Col> */}
        <Col xs={12} sm={8} md={6}>
          <StatBox
            title="ค่างวด"
            value={loan?.totalJugde}
            color={THEME.info}
            icon={<WarningOutlined />}
          />
        </Col>
        <Col xs={12} sm={8} md={6}>
          <StatBox
            title="คงเหลือ"
            value={Math.max(0, totalJudgement - totalPaidAll)}
            color="green"
            icon={<DollarOutlined />}
          />
        </Col>
      </Row>
      <Divider style={{ margin: "20px 0" }} />
      <Row gutter={[32, 16]}>
        <Col xs={12} sm={8} md={4}>
          <InfoItem
            label="วันทำสัญญา"
            value={formatDate(loan?.SDATE)}
            icon={<CalendarOutlined />}
          />
        </Col>
        <Col xs={12} sm={8} md={4}>
          <InfoItem label="งวดแรก" value={formatDate(loan?.FDATE)} />
        </Col>

        <Col xs={12} sm={8} md={4}>
          <InfoItem label="จำนวนงวด" value={`1 งวด`} />
        </Col>
        <Col xs={12} sm={8} md={4}>
          <InfoItem
            label="งวดละ"
            value={`${formatMoney(loan?.totalJugde)} บาท`}
          />
        </Col>
        <Col xs={12} sm={8} md={4}>
          <InfoItem label="เบี้ยปรับ" value={dataBeeypup()} />
        </Col>
        <Col xs={12} sm={8} md={4}>
          <InfoItem label="สัญญาเก่าคือ" value={`${loan?.CONTNO || "-"}`} />
        </Col>
        <Col xs={12} sm={8} md={4}>
          <InfoItem label="สัญญาใหม่" value={`${loan?.newContno || "-"}`} />
        </Col>
      </Row>
    </StyledCard>
  );
};

export default LoanNewInfoJudgeTab;
